import { Injectable } from "@angular/core";
import { RouterStateSnapshot, ActivatedRouteSnapshot, Router, Data } from '@angular/router';
import { UserService } from "..";

@Injectable()
export class SponsorGuard  {
    constructor(private userService: UserService, private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var user = this.userService.user();
        if (this.userService.isLoggedIn() && (this.userService.isUserSponsor() || this.userService.isUserAdmin())) {
            return true;
        }
        return false;
    }
}
